<template>
	<b-nav-item-dropdown
		right
		toggle-class="d-flex align-items-center dropdown-user-link"
		class="dropdown-user"
	>
		<template #button-content>
			<div class="d-sm-flex d-none user-nav">
				<p class="user-name font-weight-bolder mb-0">
					{{ userData.name || userData.user_name }}
				</p>
				<span class="user-status">{{ arrayToStringRoleName(userData) }}</span>
			</div>
			<b-avatar
				size="40"
				:src="url"
				variant="light-primary"
				badge
				class="badge-minimal"
				badge-variant="success"
			>
				<feather-icon v-if="!userData.name" icon="UserIcon" size="22" />
			</b-avatar>
		</template>

		<b-dropdown-item
			:to="{ name: 'pages-account-setting' }"
			link-class="d-flex align-items-center"
		>
			<feather-icon size="16" icon="SettingsIcon" class="mr-50" />
			<span>Settings</span>
		</b-dropdown-item>
		<b-dropdown-item link-class="d-flex align-items-center" @click="logout">
			<feather-icon size="16" icon="LogOutIcon" class="mr-50" />
			<span>Logout</span>
		</b-dropdown-item></b-nav-item-dropdown
	>
</template>

<script>
import {
	BNavItemDropdown,
	BDropdownItem,
	BDropdownDivider,
	BAvatar,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import { initialAbility } from "@/libs/acl/config";
import useJwt from "@/auth/jwt/useJwt";
import axiosIns from "@/libs/axios";
export default {
	components: {
		BNavItemDropdown,
		BDropdownItem,
		BDropdownDivider,
		BAvatar,
	},
	data() {
		return {
			userData: JSON.parse(sessionStorage.getItem("userData") || localStorage.getItem("userData") || "null"),
			avatar: "",
			url: null,
			avatarText,
		};
	},
	methods: {
		userInformation() {
			axiosIns
				.get("web/me")
				.then((response) => {
					if (response.data.user && response.data.user.user_image) {
						this.url = response.data.user.user_image.url;
					}
				})
				.catch(() => {});
		},
		logout() {
			sessionStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
			sessionStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);
			sessionStorage.removeItem("userData");
			sessionStorage.removeItem("user-role");
			localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
			localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);
			localStorage.removeItem("userData");
			localStorage.removeItem("hatchery_id");
			localStorage.removeItem("role");
			localStorage.removeItem("company_id");
			this.$ability.update(initialAbility);
			this.$router.push({ name: "auth-login" });
		},
		capitalize(str) {
			return str.replace(/\b\w/g, (c) => c.toUpperCase());
		},
		arrayToStringRoleName(user) {
			if (user && user.role) {
				return this.capitalize(user.role.toString().replace(/\_/g, " "));
			}
			return "";
		},
	},
	created() {
		this.userInformation();
	},
};
</script>
